module.exports = "@import url('https://fonts.googleapis.com/css?family=Cabin');\n\n.logo {\n  height: 300px;\n}\n\n.selected {\n  background-color: #CFD8DC !important;\n  color: white;\n}\n\n.welcome {\n  margin-top: 10px;\n  height: auto;\n}\n\n@media only screen and (max-width: 768px) {\n  .logo {\n    width: 100%;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.css
// module id = ./src/app/home/home.css
// module chunks = main